<template lang="pug">
  header.login-header
    .login-header__wrap(:class="hasAside ? 'ods-justify-between' : 'ods-justify-center'")
      login-logo
      .login-header__aside(v-if="hasAside")
        lang-selector(
          v-if="multiLanguage"
          size='deci'
        )
        div(:class="multiLanguage && 'login-header__client-logo'" v-if="withProjectLogo")
          img(
            v-if='withProjectLogo'
            :src="urlLogo"
            alt="logo")

    .login-header__title(:class="hasAside ? 'ods-justify-start' : 'ods-justify-center'", :style="hasRenfe")
      h1 {{ productName }}

</template>

<script>
import { mapGetters } from 'vuex'
import LoginLogo from '@/components/logingeneric/LogoOnesait'
import LangSelector from '@/components/shared/LangSelector'

export default {
  name: 'LoginHeader',

  components: {
    LoginLogo,
    LangSelector
  },

  props: {
    productName: {
      type: String
    },
    multiLanguage: {
      type: Boolean
    },
    clientLogo: {
      type: Boolean
    }
  },

  computed: {
    ...mapGetters(['loadmenulogo']),
    hasAside () {
      return this.multiLanguage || this.clientLogo
    },
    hasRenfe () {
      if (this.$route.path.includes('renfe')) {
        return {
          'background-color': '#8a0072'
        }
      } else if (this.$route.path.includes('Canal')) {
        return {
          'background-color': '#0084c9'
        }
      } else if (this.$route.path.includes('lyntia')) {
        return {
          'background-color': '#351b51'
        }
      } else if (this.$route.path.includes('accionaenergia')) {
        return {
          'background-color': '#ff0000'
        }
      } else if (this.$route.path.includes('correos')) {
        return {
          'background-color': '#002E6D'
        }
      } else if (this.$route.path.includes('vocento')) {
        return {
          'background-color': '#1A206D'
        }
      } else if (this.$route.path.includes('ree')) {
        return {
          'background-color': '#003C6E'
        }
      } else if (this.$route.path.includes('red.es')) {
        return {
          'background-color': '#C8103A'
        }
      }
      return ''
    },
    withProjectLogo () {
      if (this.loadmenulogo && this.loadmenulogo !== null) {
        return true
      }
      return false
    },
    urlLogo () {
      console.log('LOGO:' + this.loadmenulogo)
      if (this.withProjectLogo) {
        if (this.loadmenulogo && this.loadmenulogo !== null) {
          return require('@/assets/images/projects/' + this.loadmenulogo)
        } else {
          return require('@/assets/images/projects/' + this.activeUser.data.projects[0].personalization.logo)
        }
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-header {
  &__wrap {
    display: flex;
    align-items: center;
    width: 100%;
    height: rem(56);

    padding: $space-200;
    border-bottom: $border-size-200 solid var(--color-border-hard-divisor);
    text-align: center;

    & > svg path {
      fill: var(--color-txt-primary);
    }
  }

  &__title {
    display: flex;
    align-items: center;
    height: rem(39);

    padding: $space-100 $space-200;
    background-color: var(--color-bg-notification);

    @include txt-body-500;
    color: var(--color-txt-negative);
  }

  &__aside {
    display: flex;
    align-items: center;
  }

  &__client-logo {
    img {
      height: rem(36);
    }
    padding-left: $space-100;
    margin-left: $space-100;
    border-left: $border-size-200 solid var(--color-border-hard-divisor);
  }
}
</style>
